import React from 'react';
import { useAssets } from '../hooks/useAssets';

/**
 * AssetSelect — replaces raw "Asset ID" number inputs with a named dropdown.
 *
 * Props: value, onChange, required, placeholder, className
 */
export default function AssetSelect({ value, onChange, required, placeholder = 'Select asset…', className = '' }) {
  const { assets, loading } = useAssets();

  return (
    <select
      value={value || ''}
      onChange={onChange}
      required={required}
      disabled={loading}
      className={`w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500/30 bg-white disabled:bg-gray-50 disabled:text-gray-400 ${className}`}
    >
      <option value="">{loading ? 'Loading assets…' : placeholder}</option>
      {assets.map(a => (
        <option key={a.id} value={a.id}>
          {a.name} ({a.asset_code}) — {a.asset_type} · {a.capacity_mw ? `${a.capacity_mw} MW` : 'capacity N/A'}
        </option>
      ))}
    </select>
  );
}
